import React from 'react';
import {PATHS} from '../Routes';
import {useComputedReservationDetails} from '../context/computedReservationDetails';

function useRegisterSteps() {
  const {
    hasDeposits,
    hasBiomatch,
    hasScanDocument,
    hasTaxes,
    isSomePayments,
    paymentsDetails,
  } = useComputedReservationDetails();

  const steps = React.useMemo(() => {
    const steps = [];

    // if (isLeaderGuest) {
    steps.push(PATHS.confirmBooking);
    // }
    if (hasBiomatch || hasScanDocument) {
      steps.push(PATHS.verificationResult);
    }

    steps.push(PATHS.formPersonalData);

    if (hasDeposits) {
      steps.push(PATHS.protect);
    }

    if (hasTaxes) {
      steps.push(PATHS.touristTaxes);
    }

    if (isSomePayments || hasTaxes || paymentsDetails?.booking.activated) {
      steps.push(PATHS.pay);
    }

    return steps;
  }, [
    paymentsDetails?.booking.activated,
    hasBiomatch,
    hasDeposits,
    hasScanDocument,
    hasTaxes,
    isSomePayments,
  ]);

  const getCurrentStep = React.useCallback(
    (step: PATHS) => {
      const foundStep = steps.indexOf(step) + 1;
      if (foundStep >= 0) return foundStep;
      return 0;
    },
    [steps],
  );

  return {count: steps.length, getCurrentStep};
}

export {useRegisterSteps};
